

export type Meta = {
  name: string
  chartName: string
}

export const DefaultMeta: Meta = {
  name: "",
  chartName: "",
}
